import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import SectionHeader from '@monorepo/shared/src/components/layout/SectionHeader';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import { AppRoutes } from 'types';
import AssignLetterContainer from './components/AssignLetterContainer';
import AssignLetterFooter from './components/AssignLetterFooter';
import useTrialUserOmitRoutes from 'state/hooks/use-trial-user-omit-routes';
import useUserStore from '@monorepo/shared/src/graph/hooks/use-user';
import { isTrialLicense } from '@monorepo/shared/src/graph/selectors/license-selector';

const tAssignment = (key, options?) => translate('assignment', key, options);

const AssignLetter: React.FC = () => {
  const params = useParams();
  const navigate = useNavigate();
  const omitRoutes = useTrialUserOmitRoutes();
  const letter = params?.letter;
  const letters = `${letter?.toUpperCase()}${letter?.toLowerCase()}`;

  const [{ me }] = useUserStore();
  const license = me?.licenses?.[0];
  const isTrialUser = isTrialLicense(license);

  useEffect(() => {
    if (isTrialUser) navigate('/home');
  }, [isTrialUser]);

  const handleClose = () => {
    navigate(`/${AppRoutes.ASSIGNMENTS}`);
  };

  return (
    <>
      <SectionHeader
        omitRoutes={omitRoutes}
        backRoute={`/${AppRoutes.ASSIGNMENTS}`}
        closeButtonAction={handleClose}
        title={tAssignment('assignLetterTitle', {
          letters,
        })}
      />
      <AssignLetterContainer />
      <AssignLetterFooter />
    </>
  );
};

export default AssignLetter;
